import vipAirOrder from "./vipAirOrder";

export default {
  vipAirOrder,
};
